/* eslint-disable @typescript-eslint/no-explicit-any */

export function Singleton<T extends new (...args: any[]) => any>(cls: T): T {
  const instances = new WeakMap();

  const getInstance = (target: any) => {
    if (!instances.has(target)) {
      instances.set(target, null);
    }
    return instances.get(target);
  };

  const decorated = new Proxy(cls, {
    construct(target, args) {
      let instance = getInstance(target);

      if (!instance) {
        instance = new target(...args);
        instances.set(target, instance);

        // Add destroyInstance method to the instance
        (instance as any).destroyInstance = () => {
          instances.set(target, null);
        };
      }

      return instance;
    },
  });

  return decorated;
}
